import { application } from "./application"

import TabsController from "./tabs_controller"
import ClipboardController from "./clipboard_controller"
import OutboundController from "./outbound_controller"
import YoutubeController from "./youtube_controller"
import TrackController from "./track_controller"
import TerminalController from "./terminal_controller"
import RevealController from "./reveal_controller"
import CountupController from "./countup_controller"

application.register("tabs", TabsController)
application.register("clipboard", ClipboardController)
application.register("outbound", OutboundController)
application.register("youtube", YoutubeController)
application.register("track", TrackController)
application.register("terminal", TerminalController)
application.register("reveal", RevealController)
application.register("countup", CountupController)
